import { ArrowBackIos, ArrowForwardIos, Close, Edit, Delete, Print, Translate, Save } from '@mui/icons-material';
import { Modal, Button, IconButton, Box, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress } from '@mui/material';
import { Dropdown, message, Select } from 'antd';
import { useReactToPrint } from 'react-to-print';
import LessionPlanPrinter from 'modules/lessonPlan/teacher/LessionPlanPrinter';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { find, findIndex, get, shuffle, slice } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useAllBook } from 'store/books/selectors';
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import { useCurrentUser } from 'store/users/selectors';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import { DownOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd/lib';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { useLessonPlansByBookAndUser } from 'store/lesson_plan/selectors';
import { useDispatch } from 'react-redux';
import { handleDeleteLessonPlanByBookAndUser, handleListLessonPlanByBookAndUser, handleCreateOrUpdateLessonPlan, handleGenerateEnglishLessonPlan } from 'store/lesson_plan/thunks';
import LessonPlanEditButton from './LessonPlanEditButton';
import EmbeddedLessonPlanEditor from './EmbeddedLessonPlanEditor';
import HTMLContentPrinter from './HTMLContentPrinter';
import { useMobileDetect, useTabletDetection } from 'containers/chat/hooks';
import ImageModal from 'components/Modals/imageModal';
import SentryWrap from 'components/Sentry';

const LessonPlan = ({
  lessonPlanData,
  handlePrintLessons,
  lessionPrintLoader,
  pageId,
  imageRef,
  chapter,
}) => {
  const {checkPopUpAtOnce,updatePopUpAtOnce} = usePopUpAtOnce();
  const showAlert = useAlert();
  const orgPermissions = useCurrentOrgPermission();
  const currentUser = useCurrentUser();
  const booksAllList = useAllBook();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [lessonPlanPages, setLessonPlanPages] = useState([]);
  const [lessonPageindex, setLessonPageIndex] = useState(0);
  const [selectedLessonPlan, setSelectedLessonPlan] = useState({});
  const backBtnRef = useRef(null);
  const forwardBtnRef = useRef(null);
  const [learnPlanModal, setLearnPlanModal] = useState(false);
  const [myLessonPlanModal, setMyLessonPlanModal] = useState(false);
  const [isLessonPlanDropdownOpen, setIsLessonPlanDropdownOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [printLoader, setPrintLoader] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('spanish');
  const [isGeneratingEnglish, setIsGeneratingEnglish] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [currentImageSrc, setCurrentImageSrc] = useState(null);
  const printRef = useRef();
  const editorRef = useRef();
  const dispatch = useDispatch();
  const isTablet = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablet;
  const hasLessionPlanPage = useMemo(() => lessonPlanData ? find(lessonPlanData, (p) => p.page == pageId) : null, [lessonPlanData, pageId]);
  const book_lesson_plan = useLessonPlansByBookAndUser();
  const selected_page_plan = useMemo(() => {
    if(Array.isArray(book_lesson_plan) && book_lesson_plan.length > 0&&selectedLessonPlan&&selectedLessonPlan.page){
      return book_lesson_plan.find((pl) => pl.page_id == selectedLessonPlan.page);
    }
    return null;
  }, [book_lesson_plan, selectedLessonPlan]);
  const currentpage_plan = useMemo(() => {
    if(Array.isArray(book_lesson_plan) && book_lesson_plan.length > 0&&pageId){
      return book_lesson_plan.find((pl) => pl.page_id == pageId && pl.created_by == currentUser?.id);
    }
    return null;
  }, [book_lesson_plan, pageId,currentUser?.id]);

  // Helper function to determine if we should show editor or image view
  const shouldShowEditor = useMemo(() => {
    return selectedLessonPlan?.content_type && selectedLessonPlan.content_type !== 'Image';
  }, [selectedLessonPlan?.content_type]);

  const sortedLessonData = useMemo(() => {
    if (!lessonPlanData) return [];
    return [...lessonPlanData].sort((a, b) => Number(a.page) - Number(b.page));
  }, [lessonPlanData]);

  const lessionPlanFromIndex = useMemo(() => {
    return findIndex(lessonPlanPages, (p) => p.pageId == get(selectedLessonPlan, 'from', 0));
  }, [lessonPlanPages, selectedLessonPlan]);

  const lessonPlanToIndex = useMemo(() => {
    return findIndex(lessonPlanPages, (p) => p.pageId == get(selectedLessonPlan, 'to', 0));
  }, [lessonPlanPages, selectedLessonPlan]);

  function checkKey(e) {
    let isLessonPlan = document.getElementsByClassName('lessonPlanPopUp').length > 0;
    let isRubricsPlan = document.getElementsByClassName('rubricsPopUp').length > 0;
    if (isLessonPlan || isRubricsPlan) {
      e = e || window.event;
      if (e.keyCode == '37') {
        if (backBtnRef.current && !backBtnRef.current.disabled) {
          backBtnRef.current.click();
        }
      } else if (e.keyCode == '39') {
        if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
          forwardBtnRef.current.click();
        }
      }
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', checkKey);
    return () => {
      document.removeEventListener('keydown', () => {});
    };
  }, []);

  const getSrcPage = () => {
    if (lessonPlanPages) {
      const page = lessonPlanPages[lessonPageindex];
      return page ? page.resource : null;
    }
  };

  const handleIndividualLessonClick = (lessonData, lessonName) => {
    if (checkPopUpAtOnce()) {
      return;
    }
    const lessonPlanBook = find(booksAllList, (book) => book.id == lessonData.resourceId);

    if (!lessonPlanBook) {
      console.error('Lesson plan book not found for resourceId:', lessonData.resourceId);
      return;
    }

    const lessionPlanPages = get(lessonPlanBook, 'pages', []);

    if (get(orgPermissions, 'lessonPlan', true)) {
      setLearnPlanModal(true);
      const fromIndex = findIndex(lessionPlanPages, (p) => p.pageId == get(lessonData, 'from', 0));
      setLessonPageIndex(fromIndex);
    } else {
      showAlert('Restricted access (legend)', 'error');
      return;
    }

    setLessonPlanPages(lessionPlanPages);
    setSelectedLessonPlan({ ...lessonData, name: lessonName });
  };

  const handleViewLessonPlan = () => {
    if (hasLessionPlanPage) {
      handleIndividualLessonClick(hasLessionPlanPage);
    }
    setIsLessonPlanDropdownOpen(false);
  };

  const handleViewMyLessonPlan = () => {
    setMyLessonPlanModal(true);
    setIsLessonPlanDropdownOpen(false);
  };

 


  const handleDeleteMyLessonPlan = () => {
    setShowDeleteDialog(true);
  };

  const handleDeleteConfirm = async () => {
    if (!currentpage_plan?.id) {
      message.error('No lesson plan found to delete.');
      return;
    }

    setIsDeleting(true);
    
    try {
      const result = await dispatch(handleDeleteLessonPlanByBookAndUser(currentpage_plan.id));
      
      if (result && !result.error) {
        message.success('Lesson plan deleted successfully!');
        await dispatch(handleListLessonPlanByBookAndUser(currentpage_plan.chapter || chapter, currentUser?.id));
        setMyLessonPlanModal(false);
        setShowDeleteDialog(false);
      } else {
        message.error(result?.error || 'Failed to delete lesson plan');
      }
    } catch (error) {
      console.error('Error deleting lesson plan:', error);
      message.error('Failed to delete lesson plan');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteDialog(false);
  };

  const handleLanguageChange = (value) => {
    setCurrentLanguage(value);
  };

  const handleGenerateEnglishContent = async () => {
    if (!currentpage_plan?.content) {
      showAlert('No Spanish content available to translate', 'error');
      return;
    }

    setIsGeneratingEnglish(true);
    try {
      const result = await dispatch(handleGenerateEnglishLessonPlan(
        currentpage_plan.id, 
        currentUser.id, 
        currentpage_plan.chapter || chapter,
        currentpage_plan.created_by === "admin"
      ));
      
      if (result && result.content_english) {
        // Refresh the lesson plans list to get updated data
        await dispatch(handleListLessonPlanByBookAndUser(currentpage_plan.chapter || chapter, currentUser.id));
        
        // Switch to English view
        setCurrentLanguage('english');
        
        showAlert('English content generated successfully! Switched to English view.', 'success');
      } else {
        showAlert('Failed to generate English content', 'error');
      }
    } catch (error) {
      console.error('Error generating English content:', error);
      showAlert('Error generating English content', 'error');
    } finally {
      setIsGeneratingEnglish(false);
    }
  };

  const handleTranslateGenerator = async () => {
    if (!selected_page_plan?.content) {
      showAlert('No Spanish content available to translate', 'error');
      return;
    }

    setIsGeneratingEnglish(true);
    try {
      const result = await dispatch(handleGenerateEnglishLessonPlan(
        selected_page_plan.id, 
        currentUser.id, 
        selected_page_plan.chapter || chapter,
        selected_page_plan.created_by === "admin"
      ));
      
      if (result && result.content_english) {
        await dispatch(handleListLessonPlanByBookAndUser(selected_page_plan.chapter || chapter, currentUser.id));
        setCurrentLanguage('english');
        showAlert('English content generated successfully! Switched to English view.', 'success');
      } else {
        showAlert('Failed to generate English content', 'error');
      }
    } catch (error) {
      console.error('Error generating English content:', error);
      showAlert('Error generating English content', 'error');
    } finally {
      setIsGeneratingEnglish(false);
    }
  };

  const handleEditorUpdate = async (content) => {
    if (!selected_page_plan?.id) {
      message.error('No lesson plan found to update.');
      return;
    }

    setIsUpdating(true);
    try {
      // Prepare update data based on current language
      const updateData = {
        id: selected_page_plan.id,
        page_id: selected_page_plan.page_id,
        chapter: selected_page_plan.chapter || chapter,
        created_by: currentUser?.id,
        user_type: currentUser?.role,
        parent_id: selected_page_plan.parent_id || selected_page_plan.id
      };

      // Update content based on current language
      if (currentLanguage === 'english') {
        updateData.content_english = content;
        updateData.content = selected_page_plan.content; // Keep original Spanish content
      } else {
        updateData.content = content;
        updateData.content_english = selected_page_plan.content_english; // Keep existing English content if any
      }

      const result = await dispatch(handleCreateOrUpdateLessonPlan(updateData));
      
      if (result && !result.error) {
        message.success('Lesson plan updated successfully!');
        // Refresh the lesson plan data
        await dispatch(handleListLessonPlanByBookAndUser(selected_page_plan.chapter || chapter, currentUser?.id));
      } else {
        message.error(result?.error || 'Failed to update lesson plan');
      }
    } catch (error) {
      console.error('Error updating lesson plan:', error);
      message.error('Failed to update lesson plan');
    } finally {
      setIsUpdating(false);
    }
  };

  const validationPrint = () => {
    if (isMobile || isTablet) {
      showAlert("Print is not supported on this device!", "error");
      return;
    } else {
      printCall();
    }
  };

  const printCall = useReactToPrint({
    contentRef: printRef,
    onBeforeGetContent: async () => { setPrintLoader(true) },
    onBeforePrint: async () => {
      setPrintLoader(false);
    }
  });



  const menuNav = useMemo(() => {
    const items = sortedLessonData?.map((p, index) => {
      const isCurrentPage = Number(pageId) === Number(p.page);
      const isSelectedPage = Number(selectedLessonPlan.page) === Number(p.page);

      return {
        key: `${p.resourceId}-${p.page}-${index}`,
        label: p?.levelTitle ? p?.levelTitle : `${index + 1}. Lesson Plan `,
        className: `contextCenter`,
        style: {
          whiteSpace: 'nowrap',
          backgroundColor: isCurrentPage ? 'purple' : isSelectedPage ? '#00a6a6' : '#fff',
          color: isCurrentPage ? 'white' : isSelectedPage ? '#fff' : '#000',
        },
        onClick: () =>
          handleIndividualLessonClick(
            p,
            p?.levelTitle ? p?.levelTitle : `${index + 1}. Lesson Plan `,
          ),
      };
    });

    return {
      items: items,
    };
  }, [sortedLessonData, selectedLessonPlan.page, pageId]);

  const lessonPlanDropdownMenu = useMemo(() => {
    const items = [
      {
        key: 'view-lesson-plan',
        label: 'View Lesson Plan',
        onClick: handleViewLessonPlan,
      },
      {
        key: 'view-my-lesson-plan',
        label: 'View My Lesson Plan',
        onClick: handleViewMyLessonPlan,
      },
    ];

    return {
      items: items,
    };
  }, [hasLessionPlanPage,booksAllList]);

  const handleVisibleChange = (visible) => {
    setIsDropdownOpen(visible);
  };

  const onClose = () => {
    setLearnPlanModal(false);
    setLessonPageIndex(0);
    setLessonPlanPages([]);
    setSelectedLessonPlan({});
    setLessonPageIndex(0);
    setImageModalOpen(false);
    setCurrentImageSrc(null);
  };

  const handleImageClick = () => {
    const imageSrc = getSrcPage();
    if (imageSrc) {
      setCurrentImageSrc(imageSrc);
      setImageModalOpen(true);
    }
  };

  const onMyLessonPlanClose = () => {
    setMyLessonPlanModal(false);
  };
 

  return (
    <SentryWrap>
    <div>
      {hasLessionPlanPage && currentUser?.role !== 'student' ? (
        currentpage_plan ? (
          <Dropdown
            menu={lessonPlanDropdownMenu}
            placement="bottomLeft"
            trigger={['click']}
            open={isLessonPlanDropdownOpen}
            onOpenChange={setIsLessonPlanDropdownOpen}
          >
            <LessionPlan>
              <LessionPlanInner className="text-wrap">
                <Tooltip
                  title={
                    hasLessionPlanPage?.levelTitle ? hasLessionPlanPage?.levelTitle : 'Lesson Plan'
                  }
                  placement="top"
                >
                  {hasLessionPlanPage?.levelTitle ? hasLessionPlanPage?.levelTitle : 'Lesson Plan'}
                  <DownOutlined
                    className={isLessonPlanDropdownOpen ? 'rotate-icon' : ''}
                    style={{
                      transition: 'transform 0.3s',
                      transform: isLessonPlanDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                      marginLeft: '8px',
                    }}
                  />
                </Tooltip>
              </LessionPlanInner>
            </LessionPlan>
          </Dropdown>
        ) : (
          <LessionPlan onClick={() => handleIndividualLessonClick(hasLessionPlanPage)}>
            <LessionPlanInner className="text-wrap">
              <Tooltip
                title={
                  hasLessionPlanPage?.levelTitle ? hasLessionPlanPage?.levelTitle : 'Lesson Plan'
                }
                placement="top"
              >
                {hasLessionPlanPage?.levelTitle ? hasLessionPlanPage?.levelTitle : 'Lesson Plan'}
              </Tooltip>
            </LessionPlanInner>
          </LessionPlan>
        )
      ) : null}

      <Modal
        open={learnPlanModal}
        onClose={onClose}
        className={'lessonPlanPopUp'}
        style={{
          height: '100%',
          width: '100%',
          backgroundColor: 'transparent',
        }}
      >
        <LearnPlanWrapper>
          <LessionPlanContainer>
            <DropdownContainer>
              <StyledDropdown
                menu={menuNav}
                placement="bottomLeft"
                trigger={['click']}
                getPopupContainer={(trigger) => trigger.parentNode}
                onOpenChange={handleVisibleChange}
                open={isDropdownOpen}
                overlayClassName="lesson-plan-dropdown-menu"
              >
                <LessionPlan>
                  <LessionPlanInner className="gap-5px text-wrap">
                    {selectedLessonPlan?.name
                      ? selectedLessonPlan?.name
                      : selectedLessonPlan?.levelTitle
                        ? selectedLessonPlan?.levelTitle
                        : 'All Lesson Plans'}
                    <DownOutlined
                      className={isDropdownOpen ? 'rotate-icon' : ''}
                      style={{
                        transition: 'transform 0.3s',
                        transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                      }}
                    />
                  </LessionPlanInner>
                </LessionPlan>
              </StyledDropdown>
            </DropdownContainer>

            <CloseBtn onClick={onClose}>
              <Close style={{ color: '#fff', fontWeight: 'bolder', fontSize: 25 }} />
            </CloseBtn>
            <div
              className="lessonPlanUpdateSpanishButtons"
            
            >
              {/* Show edit button for Image content type or undefined */}
              {(!selectedLessonPlan?.content_type || selectedLessonPlan.content_type === 'Image') && (
                <LessonPlanEditButton
                  selectedPagePlan={selected_page_plan}
                  onPrintSingle={handlePrintLessons}
                  printLoader={lessionPrintLoader}
                />
              )}
              
              {/* Show Update/Delete buttons for non-Image content types */}
              {shouldShowEditor && selected_page_plan && (
                <>
                
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => {
                      const currentContent = editorRef.current?.getCurrentContent() || '';
                      handleEditorUpdate(currentContent);
                    }}
                    disabled={!editorRef.current?.getCurrentContent()?.trim() || isUpdating}
                    size="small"
                    startIcon={<Save />}
                    sx={{
                      background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                      height: '36px',
                      minHeight: '36px',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #0f8078 0%, #2ed368 100%)',
                      },
                      '&:disabled': {
                        background: 'rgba(0, 0, 0, 0.12)',
                      }
                    }}
                  >
                    {isUpdating ? 'Updating...' : 'Update'}
                  </Button>
                  {selected_page_plan?.content_english ? (
                    <StyledSelect
                      value={currentLanguage}
                      onChange={(value) => setCurrentLanguage(value)}
                      style={{ minWidth: 120, height: 36 }}
                      size="small"
                      placement="bottomLeft"
                      getPopupContainer={() => document.body}
                      dropdownStyle={{ zIndex: 3000 }}
                      options={[
                        { value: 'spanish', label: '🇪🇸 Spanish' },
                        { value: 'english', label: '🇺🇸 English' }
                      ]}
                    />
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleTranslateGenerator}
                      disabled={isGeneratingEnglish || isUpdating}
                      size="small"
                      startIcon={isGeneratingEnglish ? <CircularProgress size={16} /> : <Translate />}
                      sx={{
                        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                        height: '36px',
                        minHeight: '36px',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #3a8ee6 0%, #00d4e6 100%)',
                        },
                        '&:disabled': {
                          background: 'rgba(0, 0, 0, 0.12)',
                        }
                      }}
                    >
                      {isGeneratingEnglish ? 'Translating...' : 'Translate to English'}
                    </Button>
                  )}
                  {selected_page_plan?.created_by !== 'admin' && (
                    <Button
                      variant="contained"
                      color="error"
                      onClick={handleDeleteMyLessonPlan}
                      disabled={isUpdating}
                      size="small"
                      startIcon={<Delete sx={{ color: 'white !important' }} />}
                      sx={{
                        background: 'linear-gradient(135deg, #f857a6 0%, #ff5858 100%)',
                        color: 'white',
                        height: '36px',
                        minHeight: '36px',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #e04395 0%, #e84343 100%)',
                        },
                        '&:disabled': {
                          background: 'rgba(0, 0, 0, 0.12)',
                        }
                      }}
                    >
                      {isUpdating ? 'Deleting...' : 'Delete'}
                    </Button>
                  )}
                </>
              )}
              
              {shouldShowEditor ? (
                <HTMLContentPrinter
                  onPrintSingle={handlePrintLessons}
                  printLoader={lessionPrintLoader}
                  htmlContent={
                    currentLanguage === 'english' && selected_page_plan?.content_english 
                      ? selected_page_plan.content_english 
                      : selected_page_plan?.content
                  }
                  hasModifiedChange={() => {
                    const current = editorRef.current?.getCurrentContent();
                    const saved = currentLanguage === 'english' ? selected_page_plan?.content_english : selected_page_plan?.content;
                    return current != null && current !== saved;
                  }}
                  updateContent={async () => {
                    const current = editorRef.current?.getCurrentContent();
                    if (current != null) await handleEditorUpdate(current);
                  }}
                  getPrintContent={() => editorRef.current?.getCurrentContent()}
                />
              ) : (
                <LessionPlanPrinter
                  onPrintSingle={handlePrintLessons}
                  printLoader={lessionPrintLoader}
                  images={slice(
                    lessonPlanPages,
                    lessionPlanFromIndex > 0 ? lessionPlanFromIndex : 0,
                    lessonPlanToIndex >= 0 ? lessonPlanToIndex + 1 : lessonPlanPages?.length ?? 0,
                  )
                    .map((k) => k.resource)
                    .filter((k) => k)}
                />
              )}
            </div>
            {/* Navigation controls - only show for image view */}
            {!shouldShowEditor && (
              <>
                {lessonPageindex > lessionPlanFromIndex && (
                  <ButtonContainer
                    ref={backBtnRef}
                    disabled={lessonPageindex <= lessionPlanFromIndex}
                    onClick={() => {
                      setLessonPageIndex(lessonPageindex - 1);
                    }}
                    left={0}
                  >
                    <ArrowBackIos style={{ fontSize: '40px' }} />
                  </ButtonContainer>
                )}
                {lessonPageindex < lessonPlanToIndex && (
                  <ButtonContainer
                    ref={forwardBtnRef}
                    disabled={lessonPageindex >= lessonPlanToIndex}
                    onClick={() => {
                      setLessonPageIndex(lessonPageindex + 1);
                    }}
                    right={0}
                  >
                    <ArrowForwardIos style={{ fontSize: '40px' }} />
                  </ButtonContainer>
                )}
              </>
            )}
            
            
              {shouldShowEditor ? (<EditorContainer>
              <EmbeddedLessonPlanEditor
                ref={editorRef}
                lessonPlan={{
                  ...selected_page_plan,
                  content: currentLanguage === 'english' && selected_page_plan?.content_english 
                    ? selected_page_plan.content_english 
                    : selected_page_plan?.content
                }}
              />
            </EditorContainer>) : (<LessionContainer> 
              <PrintWrapper ref={imageRef}>
                <ZoomText>Click to zoom in</ZoomText>
                <Images src={getSrcPage()} onClick={handleImageClick} style={{ cursor: 'pointer' }} />
              </PrintWrapper>
            </LessionContainer>
              )}
            
          </LessionPlanContainer>
        </LearnPlanWrapper>
      </Modal>

      {/* My Lesson Plan Modal */}
      <Modal
        open={myLessonPlanModal}
        onClose={onMyLessonPlanClose}
        style={{
          height: '100%',
          width: '100%',
          backgroundColor: 'transparent',
          zIndex: 2000,
        }}
      >
        <MyLessonPlanWrapper>
          <MyLessonPlanContainer>
            <MyLessonPlanHeader>
              <Box style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <Typography variant="h4" style={{ color: 'white', fontWeight: 'bold' }}>
                  My Lesson Plan
                </Typography>
              </Box>
              <Box className="lessonPlanButton" style={{ display: 'flex', gap: '10px' }}>
                {/* Language Dropdown */}
                {currentpage_plan?.content_english && (
                  <StyledSelect
                    value={currentLanguage}
                    onChange={handleLanguageChange}
                    style={{ minWidth: 120 , height: 36 }}
                    size="small"
                    placement="bottomLeft"
                    getPopupContainer={() => document.body}
                    dropdownStyle={{ zIndex: 3000 }}
                    options={[
                      { value: 'spanish', label: '🇪🇸 Spanish' },
                      { value: 'english', label: '🇺🇸 English' }
                    ]}
                  />
                )}
                
                {currentpage_plan?.content && !currentpage_plan?.content_english && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGenerateEnglishContent}
                    disabled={isGeneratingEnglish}
                    size="small"
                    startIcon={isGeneratingEnglish ? <CircularProgress size={16} /> : <Translate />}
                    sx={{
                      background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                      height: '36px',
                      minHeight: '36px',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #3a8ee6 0%, #00d4e6 100%)',
                      },
                      '&:disabled': {
                        background: 'rgba(0, 0, 0, 0.12)',
                      }
                    }}
                  >
                    {isGeneratingEnglish ? 'Generating...' : 'Generate English'}
                  </Button>
                )}
                
                <HTMLContentPrinter
                  onPrintSingle={handlePrintLessons}
                  printLoader={lessionPrintLoader}
                  htmlContent={currentLanguage === 'spanish' ? currentpage_plan?.content : currentpage_plan?.content_english}
                />
                <LessonPlanEditButton
                selectedPagePlan={currentpage_plan}
                onDeleteSuccess={()=>setMyLessonPlanModal(false)}
              />
                {/* <Button
                  variant="contained"
                  color="success"
                  startIcon={<Edit />}
                  onClick={handleEditMyLessonPlan}
                  size="small"
                >
                  Edit
                </Button> */}
                {currentpage_plan?.created_by !== 'admin' && (
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<Delete sx={{ color: 'white !important' }} />}
                    onClick={handleDeleteMyLessonPlan}
                    disabled={isDeleting}
                    size="small"
                    sx={{
                      background: 'linear-gradient(135deg, #f857a6 0%, #ff5858 100%)',
                      color: 'white',
                      height: '36px',
                      minHeight: '36px',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #e04395 0%, #e84343 100%)',
                      },
                      '&:disabled': {
                        background: 'rgba(0, 0, 0, 0.12)',
                      }
                    }}
                  >
                    {isDeleting ? 'Deleting...' : 'Delete'}
                  </Button>
                )}
                <IconButton
                  onClick={onMyLessonPlanClose}
                  style={{ padding: 0 }}
                >
                  <Button
                  variant="contained"
                  color="error"
                  onClick={onMyLessonPlanClose}
                  size="small"
                  startIcon={<Close style={{ color: '#fff', fontWeight: 'bolder', fontSize: 25 }} />}
                   style={{ color: '#fff' }} >Close</Button>
                </IconButton>
              </Box>
            </MyLessonPlanHeader>
            
            <MyLessonPlanContent>
              <div 
                ref={printRef}
                className="lesson-plan-container printable lessonPlanSunEditorHeight"
                dangerouslySetInnerHTML={{ 
                  __html: (currentLanguage === 'spanish' ? currentpage_plan?.content : currentpage_plan?.content_english) || '<p>No content available</p>' 
                }}
                style={{
                  padding: '30px',
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  maxHeight: '70vh',
                  overflowY: 'auto',
                  lineHeight: '1.6',
                  fontFamily: 'Arial, sans-serif',
                  fontSize: '14px',
                  color: '#333',
                }}
              />
            </MyLessonPlanContent>
          </MyLessonPlanContainer>
        </MyLessonPlanWrapper>
      </Modal>
      <Dialog
        open={showDeleteDialog}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        container={() => document.body}
        style={{ zIndex: 999999 }}
        PaperProps={{
          style: { zIndex: 999999 }
        }}
        BackdropProps={{
          style: { zIndex: 999998 }
        }}
        sx={{
          '& .MuiDialog-container': {
            zIndex: '999999 !important'
          },
          '& .MuiDialog-paper': {
            zIndex: '999999 !important'
          },
          '& .MuiBackdrop-root': {
            zIndex: '999998 !important'
          }
        }}
      >
        <DialogTitle id="delete-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this lesson plan? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button 
            onClick={handleDeleteConfirm} 
            color="error" 
            variant="contained"
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
      
      <ImageModal
        open={imageModalOpen}
        close={() => {
          setImageModalOpen(false);
          setCurrentImageSrc(null);
        }}
        image={currentImageSrc}
      />
    </div>
    </SentryWrap>
  );
};

export default LessonPlan;

const StyledDropdown = styled(Dropdown)`
  .ant-dropdown-menu {
    max-height: 300px;
    min-width: 140px;
    overflow-y: auto;
  }

  /* Highlight selected item */
  .ant-dropdown-menu-item.selected-lesson {
    background-color: black !important;
    color: white !important;
    font-weight: 600 !important;
  }
`;

const StyledSelect = styled(Select)`
  .ant-select-dropdown {
    z-index: 3000 !important;
  }
  
  .ant-select-selector {
    background-color: #1976d2 !important; /* Blue color */
    color: white !important;
    border-color: #1976d2 !important;
    border-radius: 4px !important;
    height: 36px !important; /* Same height as PRINT button */
    min-height: 36px !important;
    
    .ant-select-selection-item {
      color: white !important;
      font-weight: 500 !important;
      line-height: 34px !important; /* Center text vertically */
    }

    .ant-select-arrow {
      color: white !important;
    }
  }

  /* Hover state */
  &:hover .ant-select-selector {
    background-color: #1565c0 !important; /* Darker blue on hover */
    border-color: #1565c0 !important;
  }

  /* Focused state */
  &.ant-select-focused .ant-select-selector {
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2) !important;
    border-color: #1976d2 !important;
  }
`;

const DropdownContainer = styled.div`
  position: absolute;
  z-index: 11;
  top: 4px;
  left: 0px;
`;

const PrintWrapper = styled.div``;

const ZoomText = styled.div`
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  pointer-events: none;
`;

const LessionPlan = styled.button`
    max-width: 250px;
    background-image: linear-gradient(to right, rgb(189,38,95), rgb(217,87,61));
    // border: none;
    border:1px solid #015ECC;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left:4px;

    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }

      @media (max-width: 992px) {
        // display:none;
      }
}
`;
const LessionPlanInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 5px;
  padding-right: 5px;
`;

const LearnPlanWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  overflow: hidden;
`;
const PlannerWrapper = styled.div`
  width: max-content;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap-reverse;
`;

const LessionPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
  // height: 90%;
  height: auto;
  position: relative;
  justify-content: center;
  padding: 20px;
  background-color: white;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @media Screen and (min-width: 1200px) {
    width: 60%;
  }
`;
const CloseBtn = styled.div`
  background-color: rgb(204, 80, 71);
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  z-index: 1;
`;

const Images = styled.img`
  background-color: ${COLOR.white};
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23);
  object-fit: cover;
  height: 600px;
  @media (max-width: 500px) {
    height: 50vh;
  }
  @media (max-width: 768px) {
    height: 60vh;
  }
  @media (max-width: 1600px) {
    height: 70vh;
  }
  @media print {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
`;

const LessionContainer = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  margin: 0px auto;
  max-width: 1320px;
  padding: 64px 0px 0px;
  position: relative;
  width: 100%;
  justify-content: center;
  align-items: center;
  @media (min-width: 997px) {
    flex-direction: row;
    padding: 0px 30px;
  }

  @media (max-width: 768px) {
    padding-top: 100px;
  }


`;

const EditorContainer = styled(LessionContainer)`
    margin-top: 50px;
    max-height: 80vh;
    overflow-y: auto;

    @media (max-width: 768px) {
      margin-top: 80px;
      overflow: hidden;
    }

    @media (max-width: 460px) {
      margin-top: 90px;
      overflow: hidden;
      max-height: 70vh;
      padding-top: 140px;
    }
`;

const ButtonContainer = styled.button`
  background-color: transparent;
  border: none;
  color: ${COLOR.black600};
  cursor: pointer;
  height: 40px;
  left: ${(p) => `${p.left}px`};
  outline: none;
  position: absolute;
  right: ${(p) => `${p.right}px`};
  top: 50%;
  transition: all 300ms ease;
  width: 40px;
  z-index: 1;
`;

const MyLessonPlanWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MyLessonPlanContainer = styled.div`
  background-color: #2c3e50;
  border-radius: 12px;
  padding: 20px;
  max-width: 70vw;
  max-height: 90vh;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const MyLessonPlanHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #34495e;
`;

const MyLessonPlanContent = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  /* Style the lesson plan content to match editor formatting */
  .lesson-plan-container {
    h1, h2, h3, h4, h5, h6 {
      color: #2c3e50;
      margin-top: 20px;
      margin-bottom: 10px;
      font-weight: bold;
    }
    
    h1 {
      font-size: 24px;
      padding-bottom: 10px;
    }
    
    h2 {
      font-size: 20px;
    }
    
    h3 {
      font-size: 18px;
    }
    
    p {
      margin-bottom: 10px;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
    
    ul, ol {
      margin-bottom: 10px;
      padding-left: 20px;
      word-wrap: break-word;
    }
    
    li {
      margin-bottom: 5px;
    }
    
    table {
      border-collapse: collapse;
      width: 100%;
      max-width: 100%;
      margin-bottom: 20px;
      table-layout: fixed;
      word-wrap: break-word;
    }
    
    table, th, td {
      border: 1px solid #ddd;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
    
    th, td {
      padding: 8px;
      text-align: left;
    }
    
    .se-custom-tag {
      // background-color: #f0f0f0;
      padding: 2px 0px;
      border-radius: 3px;
      font-weight: bold;
    }
    
    strong, b {
      font-weight: bold;
    }
    
    em, i {
      font-style: italic;
    }
    
    u {
      text-decoration: underline;
    }
    
    blockquote {
      border-left: 4px solid #ddd;
      margin: 10px 0;
      padding-left: 15px;
      font-style: italic;
    }
  }

  @media print {
    @page {
      size: letter;
      margin: 0px;
    }
    position: relative;
    width: auto;
    height: auto;
    overflow: visible;
    display: block;
    max-height: none !important;
    height: auto !important;

    /* Hide all scrollbars during print */
    * {
      scrollbar-width: none !important; /* Firefox */
      -ms-overflow-style: none !important; /* IE and Edge */
    }
    
    *::-webkit-scrollbar {
      display: none !important; /* Chrome, Safari, Opera */
    }

    /* Override all height and overflow restrictions for print */
    .printable {
      display: block !important;
      max-height: none !important;
      height: auto !important;
      overflow: visible !important;
      overflow-y: visible !important;
      overflow-x: visible !important;
      padding: 20px !important;
      background-color: white !important;
      border-radius: 0 !important;
      width: 100% !important;
    }

    &,
    & * {
      page-break-inside: avoid;
      max-height: none !important;
      height: auto !important;
      overflow: visible !important;
      overflow-y: visible !important;
      overflow-x: visible !important;
    }

    .lesson-plan-container {
      page-break-after: avoid;
      overflow: visible !important;
      overflow-y: visible !important;
      overflow-x: visible !important;
    }
  }
`;
